import loadable from "@loadable/component";

const Peacekeeper = loadable(() => import("./Peacekeeper.page"));

export default { component: Peacekeeper };
